import { motion, useReducedMotion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={reduce ? {} : { opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export const Chapter = ({ number, label, dark = false }) => (
  <div className="flex items-center gap-4 mb-6" data-testid={`chapter-${number}`}>
    <span
      className={`font-heading text-xs font-bold tracking-[0.35em] ${
        dark ? "text-ice/70" : "text-brand"
      }`}
    >
      {number}
    </span>
    <span className={`h-px w-10 ${dark ? "bg-ice/30" : "bg-brand/30"}`} />
    <span
      className={`text-xs font-semibold tracking-[0.35em] uppercase ${
        dark ? "text-ice/70" : "text-brand"
      }`}
    >
      {label}
    </span>
  </div>
);
